import { RootState } from 'app/store';

export const selectKpiDetails = (state: RootState) =>
  state.kpiDetails.kpiDetails;
export const selectIsLoadingKpiDetails = (state: RootState) =>
  state.kpiDetails.isLoadingKpiDetails;
